import React from 'react'

const Logout = ({logOut}) => {
  return (
    <div className="static-modal">
    <div className="modal fade" id="modal-danger-logout">
      <div
        className="modal-dialog  d-flex align-items-center"
        style={{ height: "calc(100vh - 72px)" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">Confirm Actions</h4>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to log out?</p>
          </div>
          <div className="modal-footer justify-content-end">
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={logOut}
              data-dismiss="modal"
            >
              Confirm
            </button>
          </div>
        </div>
        {/* /.modal-content */}
      </div>
      {/* /.modal-dialog */}
    </div>
  </div>
  )
}

export default Logout